import paidIcon from '../assets/images/Fireboard/paid.png';
import unpaidIcon from '../assets/images/Fireboard/unpaid.png';
import preauthIcon from '../assets/images/Fireboard/finances.png';
import preAuthPoundIcon from '../assets/images/Fireboard/pound_red.png';
import partialPaidPreAuthDollarIcon from '../assets/images/Fireboard/auth_dollar.png';
import partialPaidIcon from '../assets/images/Fireboard/partialPaid.png';
import partialPaidPreAuthPoundIcon from '../assets/images/Fireboard/auth_pound.png';
import { ReactComponent as Tab } from '../assets/images/Fireboard/MODES/Tablet.svg';
import { ReactComponent as Table } from '../assets/images/Fireboard/MODES/Table_Order.svg';
import { ReactComponent as Kiosk } from '../assets/images/Fireboard/MODES/Kiosk2.svg';
import { ReactComponent as CallIn } from '../assets/images/Fireboard/MODES/CallIn_Order.svg';
import { ReactComponent as Online } from '../assets/images/Fireboard/MODES/Online_Order.svg';
import { ReactComponent as SpeedOrder } from '../assets/images/Fireboard/MODES/Speed_Order.svg';
import { ReactComponent as WalkUp } from '../assets/images/Fireboard/MODES/walk_up.svg';
import { ReactComponent as Cubby } from '../assets/images/Fireboard/MODES/cubby_order.svg';
import { ReactComponent as CallCenter } from '../assets/images/Fireboard/MODES/callCenter.svg';
import { ReactComponent as DriveThru } from '@assets/images/DriveThru.svg';
import { ReactComponent as Counter } from '../assets/images/Fireboard/counterTop.svg';
import modEnums from '../constants/enums/modEnums';
import { APP_CONFIG } from '@constants';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

export const displayTime = (closeDate, time) => {
  let displayValue;
  const sentTime = new Date(time).getTime() / 1000;
  let closedTime;
  if (closeDate !== null) {
    closedTime = new Date(closeDate).getTime() / 1000;
  } else {
    closedTime = new Date(time).getTime() / 1000;
  }
  const timeElapsed = parseInt((closedTime - sentTime) / 60);
  if (timeElapsed < 120) {
    displayValue = `${timeElapsed}m`;
  } else {
    displayValue = '2h+';
  }
  return displayValue;
};

export const getTimeIn12HourClock = time => {
  if (!time) return;
  const splitValues = String(time).split(':');
  const hours = +splitValues[0];
  const session = hours >= 12 ? 'PM' : 'AM';
  let hrs = hours > 12 ? hours - 12 : hours;
  hrs = hrs === 0 ? 12 : hrs; // adding condition to handle 12 AM
  hrs = hrs < 10 ? `0${hrs}` : hrs;
  const mins = +splitValues[1] < 10 ? `0${+splitValues[1]}` : +splitValues[1];
  return `${hrs}:${mins} ${session}`;
};

export const getDeliverTo = check => {
  if (!check) return '- -';
  const { sourceType, tab, stationNumber, name: checkName, checkInNote, orders } = check;
  const order = orders?.[0];
  const vehicleInfo = order?.vehicleInfo || null;

  const buildDeliverToName = (checkInNote, vehicleInfo, checkName) => {
    const parts = [];
    if (checkInNote) parts.push(checkInNote);
    if (vehicleInfo) parts.push(vehicleInfo);
    if (checkName && checkName !== checkInNote) parts.push(checkName);
    return parts.join('\n') || null;
  };

  const nameString = buildDeliverToName(checkInNote, vehicleInfo, checkName);

  switch (sourceType) {
    case 0: { // POS, DEFAULT
      if (tab) return nameString || '- -';
      if (stationNumber && checkName) return `${stationNumber}\n${checkName}`;
      if (stationNumber) return stationNumber;
      if (checkName) return checkName;
      return '- -';
    }

    case 1: // KIOSK
    case 5: // CURBSIDE
    case 6: // ONLINE
    case 7: // WALKUP
    case 8: // TEXTTOPAY
    case 9: // SCANTOPAY
      return nameString || '- -';

    default:
      return nameString || check.stationNumber || '- -';
  }
};

export const formatPhoneNumber = (value) => {
  if (!value) return '';

  const digits = value.replace(/\D/g, '');

  const part1 = digits.slice(0, 3);
  const part2 = digits.slice(3, 6);
  const part3 = digits.slice(6, 10);

  if (digits.length <= 3) return `(${part1}`;
  if (digits.length <= 6) return `(${part1}) - ${part2}`;
  return `(${part1}) ${part2} - ${part3}`;
};

export const getPaidStatusIcon = (check, currency = '$') => {
  if (!check) return { paidIcon: unpaidIcon, preAuthIcon: null };

  const { tickets = [], unpaidAmount = 0, paidAmount = 0 } = check;
  const isPound = currency === '£';
  const hasPaid = paidAmount > 0;
  const hasUnpaid = unpaidAmount > 0;

  // Compute preAuth icon
  const preAuthTicket = tickets.find(
    ({ ticketStatusId, preAuth }) => ticketStatusId === 0 && preAuth
  );

  const getPreAuthIcon = () => {
    if (!preAuthTicket) return null;
    if (hasUnpaid && hasPaid)
      return isPound ? partialPaidPreAuthPoundIcon : partialPaidPreAuthDollarIcon;
    if (hasUnpaid)
      return isPound ? preAuthPoundIcon : preauthIcon;
    return null;
  };

  // Compute paid icon
  const getPaidIcon = () => {
    if (!hasUnpaid && hasPaid) return paidIcon;
    if (hasUnpaid && hasPaid) return partialPaidIcon;
    return unpaidIcon;
  };

  return {
    paidIcon: getPaidIcon(),
    preAuthIcon: getPreAuthIcon(),
  };
};

export const getTimeInHrsMins = time => {
  const convertTime = time && String(time).includes('Z');
  let date;
  if (convertTime) date = new Date(time);
  else date = new Date(time + 'Z');
  const hours = date.getHours();
  const session = hours >= 12 ? 'PM' : 'AM';

  let hrs = hours > 12 ? hours - 12 : hours;
  hrs = hrs === 0 ? 12 : hrs; // adding condition to handle 12 AM
  hrs = hrs < 10 ? `0${hrs}` : hrs;
  const mins =
    date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  return !isNaN(hrs) && !isNaN(mins) ? `${hrs}:${mins} ${session}` : '--';
};
export const getPickUpTimeInHrsMins = time => {
  const convertTime = time && String(time).includes('Z');
  let date;
  if (convertTime) date = new Date(time);
  else date = new Date(time + 'Z');
  const hours = date.getHours();

  let hrs = hours > 12 ? hours - 12 : hours;
  hrs = hrs === 0 ? 12 : hrs; // adding condition to handle 12 AM
  hrs = hrs < 10 ? `0${hrs}` : hrs;
  const mins =
    date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  return !isNaN(hrs) && !isNaN(mins) ? `${hrs}:${mins}` : null;
};

export const getCheckInTime = item => {
  if (item.checkInDate) {
    return getTimeInHrsMins(item.checkInDate);
  }
  return '- -';
};

export const getElapsedTime = check => {
  const currentTime = new Date().getTime();
  const dueTime = check.pickupDate || check.orderDate || check.openDate;
  const convertTime = dueTime?.includes('Z');
  let date;
  if (convertTime) date = new Date(dueTime);
  else date = new Date(dueTime + 'Z');
  const orderTime = new Date(date).getTime();
  return currentTime - orderTime;
};

export const getOrderNameFromOrderId = check => {
  if (!check) return {};

  const {
    orders = [],
    unpaidAmount = 0,
    tickets = [],
    totalAmount = 0,
    sourceType,
  } = check;
  const order = orders[0] || {};
  const { orderStatusId, pickUpStatus } = order;

  const baseStyles = {
    pending: {
      color: 'var(--status-pending-chip-bg)',
      border: '1px solid var(--status-pending-chip-border)',
    },
    inProgress: {
      color: 'var(--status-inprogress-chip-bg)',
      border: '1px solid var(--status-inprogress-chip-border)',
    },
    complete: {
      color: 'var(--status-complete-chip-bg)',
      border: '1px solid var(--status-complete-chip-border)',
    },
    error: {
      color: 'var(--status-error-chip-bg)',
      border: '1px solid var(--status-error-chip-border)',
    },
  };

  const hasTickets = tickets?.length > 0;
  const isPendingCondition =
    sourceType !== 0 ||
    (unpaidAmount > 0 && hasTickets && unpaidAmount !== totalAmount);

  const getStatusForOrder0 = () => ({
    status: isPendingCondition ? FLABEL().STATUS_PENDING : FLABEL().STATUS_PROGRESS,
    ...(isPendingCondition ? baseStyles.pending : baseStyles.inProgress),
  });

  const pickUpStatusMap = {
    5: FLABEL().STATUS_PICKEDUP,
    3: FLABEL().STATUS_SEE_COUNTER,
    default: FLABEL().STATUS_COMPLETE,
  };

  const getStatusForCompleted = () => ({
    status: pickUpStatusMap[pickUpStatus] || pickUpStatusMap.default,
    ...baseStyles.complete,
  });

  const errorStatuses = [8, 9, 10];
  if (errorStatuses.includes(orderStatusId)) {
    const labels = { 8: FLABEL().STATUS_CANCELLED, 9: FLABEL().STATUS_ERROR, 10: 'orderAbandoned' };
    return { status: labels[orderStatusId], ...baseStyles.error };
  }

  const statusMap = {
    0: getStatusForOrder0,
    1: () => ({ status: FLABEL().STATUS_PROGRESS, ...baseStyles.inProgress }),
    5: getStatusForCompleted,
  };

  return statusMap[orderStatusId]?.() || {};
};

const getMarketOrderIcon = (delivery, isCatering) => {
  if (isCatering && delivery) return cateringDeliveryIcon;
  if (isCatering) return cateringIcon;
  if (delivery) return marketOrderDelivery;
  return marketOrderOnline;
};

export const getCheckSourceIcon = (
  sourceType,
  color,
  delivery,
  isMarketOrder,
  isCatering,
  isTab,
) => {
  if (isMarketOrder) {
    return getMarketOrderIcon(delivery, isCatering);
  }

  switch (sourceType) {
    case 0: // POS, DEFAULT
      if (isTab === null || isTab === undefined) return 'pos';
      return isTab ? <Tab fill={color}/> : <Table fill={color}/>;

    case 1: // KIOSK
      return <Kiosk fill={color} />;
    case 5: // CURBSIDE
      return <Cubby fill={color} />;
    case 6: // ONLINE
      return <Online fill={color} />;
    case 7: // WALKUP
      return <WalkUp fill={color} />;
    case 8: // TEXTTOPAY
      return <CallIn fill={color} />;
    case 9:
      return <Counter fill={color} />;
    case 10: //Call Center Order
      return <CallCenter fill={color} />;
    case 11:
      return <SpeedOrder fill={color} />;
    default:
      return <DriveThru fill={color} />;
  }
};

export const getModeIconBgColor = (
  sourceType,
  delivery,
  isMarketOrder,
  isCatering,
  isTab
) => {
  if (isMarketOrder) {
    if (isCatering && delivery) return cateringDeliveryIcon;
    if (isCatering) return cateringIcon;
    return delivery ? marketOrderDelivery : marketOrderOnline;
  }

  const sourceTypeMap = {
    0: () => {
      if (isTab === null || isTab === undefined) return 'pos';
      return isTab ? 'rgba(142, 68, 173, 0.5)' : 'rgba(0, 137, 123, 0.5)';
    },
    1: () => 'rgba(33, 150, 243, 0.5)', // KIOSK
    5: () => 'rgba(41, 231, 255, 0.5)', // CURBSIDE
    6: () => 'rgba(63, 81, 181, 0.5)', // ONLINE
    7: () => 'rgba(233, 30, 99, 0.5)', // WALKUP
    8: () => 'rgba(255, 152, 0, 0.5)', // TEXTTOPAY
    9: () =>  'rgba(175, 180, 43, 0.5)', // counter
    10: () => 'rgba(98, 229, 98, 0.5)', // Call Center
    11: () => 'rgba(255, 87, 34, 0.5)', // Other
  };

  return (sourceTypeMap[sourceType] || (() => 'rgba(165, 106, 1, 0.5)'))();
};


export const getPaymentType = type => {
  let paymentType;
  switch (type) {
    case 0:
      paymentType = 'CASH';
      break;
    case 1:
      paymentType = 'CREDIT CARD';
      break;
    case 2:
      paymentType = 'APPLE PAY';
      break;
    case 3:
      paymentType = 'GOOGLE PAY';
      break;
    case 4:
      paymentType = 'SAMSUNG PAY';
      break;
    case 5:
      paymentType = 'GIFT CARD';
      break;
    case 6:
      paymentType = 'PAYPAL';
      break;
    case 7:
      paymentType = 'STRIPE';
      break;
    case 8:
      paymentType = 'TOAST CC';
      break;
  }
  return paymentType;
};

export const getSourceTypeNameFromSourceType = (type, isTab) => {
  switch (type) {
    case 5:
      return 'Curbside';
    case 8:
      return 'Call in';
    case 1:
      return 'Kiosk';
    case 9:
      return 'Scan to pay';
    case 0:
      return isTab ? 'Tab' : 'Table';
    case 6:
      return 'Online';
    case 7:
      return 'Walk up';
    case 10:
      return 'Call Center';
    default:
      return '';
  }
};

export const getElapsedTimeInMs = dueDate => {
  if (!dueDate) return 0;
  const currentTime = new Date().getTime();
  let date;
  if (dueDate.includes('Z')) date = new Date(dueDate);
  else date = new Date(dueDate + 'Z');
  const dueTime = new Date(date).getTime();

  return currentTime - dueTime;
};

export const getCubbySlotData = (storeCubby, checks) => {
  const checksMap = new Map();
  checks?.forEach(check => {
    const [order0] = check?.orders || [];
    const { storeCubbySlotId } = order0 || {};
    if (storeCubbySlotId) {
      checksMap.set(storeCubbySlotId, check);
    }
  });

  const { rowCount, columnCount, slots } = storeCubby || {};

  let slots2Darr = Array.from({ length: rowCount }, () =>
    Array.from({ length: columnCount }, () => null)
  );

  Array.isArray(slots) &&
    slots.length > 0 &&
    slots.forEach(slot => {
      let slotData = {
        ...slot,
        checkData: {},
      };
      const { id: slotId } = slot;
      if (slotId && checksMap.has(slotId)) {
        slotData = {
          ...slot,
          checkData: { ...checksMap.get(slotId) },
        };
      }
      slots2Darr[slot.rowNumber - 1][slot.columnNumber - 1] = slotData;
    });

  return slots2Darr;
};

export const getFormattedOpenOrCloseDate = data => {
  if (!data) return '---';
  const openOrDate = new Date(data);
  const currentDate = new Date();

  const isToday =
    openOrDate.getFullYear() === currentDate.getFullYear() &&
    openOrDate.getMonth() === currentDate.getMonth() &&
    openOrDate.getDate() === currentDate.getDate();

  if (isToday) {
    return openOrDate.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  } else {
    const datePart = openOrDate.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
    });
    const timePart = openOrDate.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });

    return `${datePart} ${timePart}`;
  }
};

export const getDoneStatusName = orders => {
  const [order0] = orders || [];
  const { orderStatusId, pickUpStatus } = order0 || {};
  let statusName = "";
  if (orderStatusId === 5 && pickUpStatus === 0)
    statusName = "Complete";
  else if (orderStatusId === 5 && pickUpStatus === 3)
    statusName = "See Counter";
  else if (orderStatusId === 5 && pickUpStatus === 5)
    statusName = "Picked Up";

  return statusName;
};

export const getOrderNameFromOrderStatusId = (orderId) => {
  switch (orderId) {
    case 5:
      return "Complete";
    case 8:
      return "Cancelled";
    case 9:
      return "Error";
    default:
      return "";
  }
}
export const getOrderNameFromId = (orderId) => {
  switch (orderId) {
    case 0:
      return 'Pending';
    case 1:
      return 'In Progress';
    case 5:
      return 'Complete';
    case 8:
      return 'Cancelled';
    case 9:
      return 'Error';
    default:
      return "";
  }
};

export const getChecksBasedOnFilters = (checkList, orderStatusType, isWalkUpIncluded, isCurbsideIncluded) => {
  if (!orderStatusType || orderStatusType === "All") return checkList;

  return checkList.filter(check => filterCheckByStatus(check, orderStatusType, isWalkUpIncluded, isCurbsideIncluded));
};

const filterCheckByStatus = (check, orderStatusType, isWalkUpIncluded, isCurbsideIncluded) => {
  const { orderStatusId, sourceType, unpaidAmount, tickets, orders, totalAmount } = check;

  const isInProgress = (check, orderStatusId, sourceType, unpaidAmount, totalAmount) => {
    const currentOrderStatusType = getOrderNameFromId(orderStatusId);
    return currentOrderStatusType === 'In Progress' ||
      (currentOrderStatusType === 'Pending' && sourceType === 0 && (unpaidAmount === 0 || unpaidAmount === totalAmount));
  };

  const isPending = (
    {
      orderStatusId,
      sourceType,
      unpaidAmount,
      tickets,
      totalAmount,
      isWalkUpIncluded,
      isCurbsideIncluded,
    }
  ) => {

    const currentOrderStatusType = getOrderNameFromId(orderStatusId);

    return (
      (sourceType === 0 &&
        currentOrderStatusType === 'Pending' &&
        unpaidAmount > 0 &&
        tickets?.length > 0 &&
        unpaidAmount !== totalAmount) ||
      (sourceType !== 0 && currentOrderStatusType === 'Pending')
    );
  };


  const isOpen = (orderStatusId) => {
    const currentOrderStatusType = getOrderNameFromOrderId(orderStatusId);
    return currentOrderStatusType !== 'Complete' && currentOrderStatusType !== 'Cancelled';
  };

  switch (orderStatusType) {
    case 'In Progress':
      return isInProgress(check, orderStatusId, sourceType, unpaidAmount, totalAmount);
    case 'Pending':
      return isPending({
        orderStatusId,
        sourceType,
        unpaidAmount,
        tickets,
        totalAmount,
        isWalkUpIncluded,
        isCurbsideIncluded,
      });
    case 'Open':
      return isOpen(orderStatusId);
    case 'Complete':
    case 'Picked Up':
    case 'See Counter':
      return orderStatusId === 5 && getDoneStatusName(orders) === orderStatusType;
    case 'Cancelled':
    case 'Error':
      return getOrderNameFromOrderStatusId(orderStatusId) === orderStatusType;
    default:
      return false;
  }
};

export const getChecksBasedOnPaidStatus = (checkList, paidAndUnpaid, partial, paid) => {
  if (paidAndUnpaid) {
    return checkList.filter(check => check.unpaidAmount === check.totalAmount); // return Unpaid
  } else if (partial) {
    return checkList.filter((check) => check.unpaidAmount !== 0 && check.paidAmount > 0)
  } else if (paid) {
    return checkList.filter((check) => check.unpaidAmount === 0 && check.totalAmount > 0)
  } else {
    return checkList; // return Both
  }
};

export const getChecksBasedOnEmployee = (checklist, employeeList) => {
  if (employeeList?.length > 0) {
    let selectedEmployeeIds = employeeList?.map(emp => emp.value);
    checklist = checklist.filter((el) => selectedEmployeeIds?.includes(el.employeeExternalId))
  }
  return checklist;
}

export const getChecksBasedOnLocation = (checklist, locationList) => {
  let selectedLocationIds = locationList?.map(emp => emp.value);
  checklist = checklist.filter((loc) => selectedLocationIds?.includes(loc.storeId))
  return checklist;
}

export const convertedDate = (selectedDate) => {
  let date = new Date(selectedDate);
  if (selectedDate && typeof selectedDate === 'string') {
    if (selectedDate.includes('Z'))
      date = new Date(selectedDate);
    else
      date = new Date(selectedDate + 'Z');
  }
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), month, day].join("-");
}

export const formateDateInddmm = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);

  const day = String(date.getDate()).padStart(2, '0');
  const month = date.toLocaleString('en-US', { month: 'short' }); // e.g. 'Jul'

  return `${day} ${month}`; // e.g. '09 Jul'
};


export const getLastCodeFromQrCode = qrCode => {
  let code = '';
  if (qrCode) {
    const qrStr = String(qrCode).trim();
    const qr = qrStr.endsWith('/') ? qrStr.slice(0, -1) : qrStr; //remove trailing slash
    const qrArray = qr.split('/');
    code = qrArray[qrArray.length - 1];

    //check for query params
    if (code.includes('?')) {
      const queryParamsArr = code.split('=');
      code = queryParamsArr[queryParamsArr.length - 1];
    }
  }
  return code;
};

export const goToView = (view, navigate) => {
  if (modEnums.List_View === view || modEnums.Tile_View === view) {
    navigate(`${APP_CONFIG.BASE_URL}/fireboard`);
  } else if (modEnums.Cubby_Manager === view) {
    navigate(`${APP_CONFIG.BASE_URL}/fireboard/cubbyManager`);
  } else if (modEnums.Order_Status_Manager === view) {
    navigate(`${APP_CONFIG.BASE_URL}/fireboard/orderStatusManger`);
  }
};

export const isObjectBlank = (obj) => {
  return (
    obj == null ||
    typeof obj !== 'object' ||
    Array.isArray(obj) ||
    Object.keys(obj)?.length === 0
  );
};

export const getBackendTheme = (themeProperties = null) => {
  try {
    let raw;
    let parsed;

    if (themeProperties && !isObjectBlank(themeProperties)) {
      parsed = themeProperties;
    } else {
      raw = window.sessionStorage.getItem('themeProperties');
      if (!raw) return 'light';
      parsed = JSON.parse(raw);
    }
    if (!parsed?.style) return 'light';

    const styleObj =
      typeof parsed.style === 'string'
        ? JSON.parse(parsed.style)
        : parsed.style;

    const modeName = styleObj?.['od-fireboardTheme']?.mode?.name;

    return modeName?.toLowerCase() === 'dark' ? 'dark' : 'light';
  } catch (e) {
    return 'light';
  }
};

export default {
  displayTime,
  getTimeIn12HourClock,
  getDeliverTo,
  getPaidStatusIcon,
  getTimeInHrsMins,
  getCheckInTime,
  getElapsedTime,
  getOrderNameFromOrderId,
  getCheckSourceIcon,
  getPaymentType,
  getElapsedTimeInMs,
  getCubbySlotData,
  getModeIconBgColor,
  getFormattedOpenOrCloseDate,
  formateDateInddmm,
  getChecksBasedOnEmployee,
  getOrderNameFromOrderStatusId,
  getPickUpTimeInHrsMins,
  isObjectBlank,
  getBackendTheme,
};
